import 'project/polyfill'
import { AppProps } from 'next/app'
import 'styles/Bootstrap.scss'
import 'styles/Global.scss'
import 'react-medium-image-zoom/dist/styles.css'
import LanguageHandler from 'components/LanguageHandler'
import { NextPageWithLayout } from 'types/nextPageWithLayout'
import NProgress from 'components/util/NProgress'
import Head from 'next/head'
import { useRouter } from 'next/router'
import React, { FC, useEffect, useMemo } from 'react'
import { nextReduxWrapper } from 'components/util/nextReduxWrapper'
import { ToastContainer } from 'components/base/Toast'
import ProfileContainer from 'components/ProfileContainer'
import { Project } from 'common/project'
import { PersistGate } from 'redux-persist/integration/react'
import { getPersistor } from 'common/store'
import cognito from 'common/cognito'
import Nav from 'components/project/nav/Nav'
import Aside from 'components/project/nav/Aside'
import AnalyticsContainer from 'components/util/AnalyticsContainer'
import CrispProvider from 'common/CrispProvider'
import FeatureFlagProvider from 'components/FeatureFlagProvider'
import AscenLogo from 'components/Logo/ascen'
import { useDevSettings } from 'common/services/useDevSettings'
import Meta from 'components/Meta'
type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout
}

type ComponentType = AppPropsWithLayout

cognito.init(Project.cognito)

export const defaultLayout: NextPageWithLayout['getLayout'] = (page) => {
  return (
    <>
      <Aside />
      <div className='aside-offset animated flex-fill'>
        <Nav />
        {page}
      </div>
    </>
  )
}
const AppComponent: FC<ComponentType> = ({ Component, pageProps }) => {
  const router = useRouter()
  const getLayout = Component.getLayout || defaultLayout

  const layout = useMemo(() => getLayout, [getLayout])

  if (router.asPath.includes('sw.js')) {
    return null
  }

  return (
    <>
      <Head>
        {!process.env.NEXT_PUBLIC_INDEX_SITE && router.pathname !== '/' && (
          <meta name='robots' content='noindex, nofollow' />
        )}
      </Head>
      <PersistGate persistor={getPersistor()}>
        <LanguageHandler>
          <Meta />
          <NProgress />
          {/*Workaround Chromium svg loading issues
        https://issues.chromium.org/issues/41337331
        */}
          <AscenLogo
            style={{ opacity: 0, position: 'absolute' }}
            pointerEvents='none'
          />
          <ProfileContainer>
            {(user: any) => (
              <FeatureFlagProvider>
                <AnalyticsContainer Component={Component} />
                {layout(<Component {...pageProps} />, pageProps, user)}
              </FeatureFlagProvider>
            )}
          </ProfileContainer>
          <CrispProvider />
          <ToastContainer />
          <div id='modal' />
          <div id='confirm' />
          <div id='alert' />
        </LanguageHandler>
      </PersistGate>
    </>
  )
}

export default nextReduxWrapper.withRedux(AppComponent)
